//
//  SDKFrameLayout.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Source type enum
export var FrameLayout;
(function (FrameLayout) {
    FrameLayout["c8"] = "C8";
    FrameLayout["c7"] = "C7";
    FrameLayout["c6"] = "C6";
    FrameLayout["c5"] = "C5";
    FrameLayout["c4"] = "C4";
    FrameLayout["c3"] = "C3";
    FrameLayout["c2"] = "C2";
    FrameLayout["c1"] = "C1";
    FrameLayout["c175"] = "C1_75";
})(FrameLayout || (FrameLayout = {}));
